import { createSelector } from '@reduxjs/toolkit';

// Models
import { IDateState } from './date.slice';
import { RootState } from '../index';

/**
 A selector function to retrieve the date data from the store
 @function
 @param {RootState} state - The root state of the Redux store
 @returns {ICoreState} The date state object from the Redux store
 */
const selectDateState = (state: RootState): IDateState => state.date;

/**
 A memoized selector function to retrieve the date data from the store
 @function
 @type {import('@reduxjs/toolkit').OutputSelector<RootState, ICoreState, (res: ICoreState) => ICoreState>}
 */
export const getDateState = createSelector(
  [selectDateState],
  (state) => state
);
